/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PetImageModel
 */
export interface PetImageModel {
    /**
     * 
     * @type {string}
     * @memberof PetImageModel
     */
    image?: string;
    /**
     * System assigned. Not modifiable during creation or update.
     * @type {string}
     * @memberof PetImageModel
     */
    imageUri?: string;
}

/**
 * Check if a given object implements the PetImageModel interface.
 */
export function instanceOfPetImageModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PetImageModelFromJSON(json: any): PetImageModel {
    return PetImageModelFromJSONTyped(json, false);
}

export function PetImageModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PetImageModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'image': !exists(json, 'image') ? undefined : json['image'],
        'imageUri': !exists(json, 'imageUri') ? undefined : json['imageUri'],
    };
}

export function PetImageModelToJSON(value?: PetImageModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'image': value.image,
        'imageUri': value.imageUri,
    };
}

